import { useFormikContext } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'src/app/hooks';
import {
  reducerUpdateTempSelectedKeywords,
  reducerUpdateTempSelectedSocialProfiles
} from 'src/features/customDashboard';
import { IFormValues } from './ModalCreateCustomDashboard';
import SelectObjectSectionNew, {
  ITabValue
} from 'src/components/Retail/ModalManageObjectRetail/components/SelectObjectSection';
import {
  defaultTabListNonRetail,
  defaultTabListRetail
} from 'src/components/Retail/ModalManageObjectRetail';

const SelectObjectSection = () => {
  const { values, setFieldValue } = useFormikContext<IFormValues>();
  const dispatch = useAppDispatch();
  const { objectList: objectListData, selectedObjectType } = useAppSelector(
    (state) => state.objectManagement
  );
  const customerType = useAppSelector(
    (state) => state.users.project.customerType
  );
  const isRetail = customerType === 'b2c';

  const [selectedObjectIds, setSelectedObjectIds] = useState<Array<string>>([]);

  const [selectedTab, setSelectedTab] = useState<ITabValue>('all');

  useEffect(() => {
    setSelectedObjectIds(values.objects.map((item) => item.id));
  }, [values.objects]);

  const getActiveSocialProfileIds = () => {
    return values.objects
      .filter((obj) => obj.streamType === 'account')
      .map((obj) => obj.id);
  };

  const getActiveKeywordIds = () => {
    return values.objects
      .filter((obj) => obj.streamType === 'keyword')
      .map((obj) => obj.id);
  };

  useEffect(() => {
    dispatch(
      reducerUpdateTempSelectedSocialProfiles(getActiveSocialProfileIds())
    );
    dispatch(reducerUpdateTempSelectedKeywords(getActiveKeywordIds()));
  }, [values.objects]);

  const objectList = objectListData.data;

  const filteredObjectsByType = useMemo(() => {
    if (objectList.length <= 0) return [];
    if (selectedObjectType === 'entity')
      return objectList.filter((object) => object.isEntity);
    if (selectedObjectType === 'object')
      return objectList.filter((object) => !object.isEntity);
    return objectList;
  }, [objectList, selectedObjectType]);

  return (
    <SelectObjectSectionNew
      objectList={filteredObjectsByType}
      activeObjectIdList={selectedObjectIds}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabList={isRetail ? defaultTabListRetail : defaultTabListNonRetail}
      onSelectObject={(objectIds: string[]) => {
        setSelectedObjectIds(objectIds);
        setFieldValue(
          'objects',
          objectList.filter((item) => objectIds.includes(item.id))
        );
      }}
      isGoogleReview={false}
      isEditing={true}
      isStreamPanel={false}
      isCustomDashboard={true}
    />
  );
};

export default SelectObjectSection;
